var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { ModelBook } from '~/models/model.book';
import { UIOpenService } from '~/services/service.ui';
import { t } from 'i18next';
export let ServiceBooks = class ServiceBooks extends BaseSingletonService {
    openBookService;
    books = observable.array([]);
    years = observable.array([]);
    defaultYear = 1000000;
    allYearsFilter = { label: t('BOOK_PAGE_FILTER_PANEL_OPTION_ALL'), value: this.defaultYear };
    originalBooks = [];
    selectedYear = this.defaultYear;
    openedBook;
    constructor(openBookService) {
        super();
        this.openBookService = openBookService;
        makeObservable(this);
    }
    getShelveBooks(shelveId) {
        return this.books.filter(book => book.shelveId === shelveId);
    }
    setSelectedYear(selectedYear) {
        this.selectedYear = selectedYear;
    }
    getYears(shelvesBooks) {
        return shelvesBooks
            .reduce((options, book) => {
            const years = [];
            const isNotExists = (date) => !options.find(option => option.value === date);
            if (book.sYear && isNotExists(book.sYear)) {
                years.push({
                    label: String(book.sYear),
                    value: book.sYear,
                });
            }
            if (book.fYear && isNotExists(book.fYear) && book.fYear !== book.sYear) {
                years.push({
                    label: String(book.fYear),
                    value: book.fYear,
                });
            }
            return [...options, ...years];
        }, [this.allYearsFilter])
            .sort((a, b) => b.value - a.value);
    }
    filterBooksByYear(year) {
        if (year === this.defaultYear) {
            this.resetFilteredData();
            return;
        }
        this.books.replace(this.originalBooks.filter(book => {
            return year && (book.sYear === year || book.fYear === year);
        }));
    }
    resetFilteredData() {
        this.books.replace(this.originalBooks);
    }
    getBook(communityId, bookId) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${communityId}/${EApiUrl.books}/${bookId}`)
                .then(response => {
                runInAction(() => {
                    this.openedBook = plainToInstance(ModelBook, response.data);
                });
            })),
        }).query();
    }
    getBooks(communityId, params) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${communityId}/${EApiUrl.books}`, {
                params,
            })
                .then(response => {
                runInAction(() => {
                    const books = plainToInstance(ModelBook, response.data);
                    this.books.replace(books);
                    this.years.replace(this.getYears(this.books.toJSON()));
                    this.originalBooks = books;
                    this.selectedYear = this.defaultYear;
                });
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", typeof (_b = typeof ModelBook !== "undefined" && ModelBook) === "function" ? _b : Object)
], ServiceBooks.prototype, "openedBook", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Array)
], ServiceBooks.prototype, "getYears", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ServiceBooks.prototype, "filterBooksByYear", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ServiceBooks.prototype, "resetFilteredData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], ServiceBooks.prototype, "getBook", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], ServiceBooks.prototype, "getBooks", null);
ServiceBooks = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object])
], ServiceBooks);
